import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // Prerendered pages are served at their directory URL (…/audi/) and the
    // host 308-redirects the slash-less form. Generate every internal href with
    // a trailing slash so links match canonical/sitemap and don't bounce
    // Googlebot through a redirect.
    trailingSlash: "always",
  });

  return router;
};
